import { render, staticRenderFns } from "./ReservarImovelDialog.vue?vue&type=template&id=2a5ab9e2&"
import script from "./ReservarImovelDialog.vue?vue&type=script&lang=js&"
export * from "./ReservarImovelDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ReservarImovelDialog.vue"
export default component.exports